import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography, Paper, Container, Divider } from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
const Home = () => {
    return (_jsx(Container, { maxWidth: "sm", children: _jsxs(Paper, { elevation: 0, sx: {
                p: 5,
                mt: 8,
                textAlign: 'center',
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 3
            }, children: [_jsx(AssignmentIcon, { sx: { fontSize: 60, color: 'primary.main', mb: 2 } }), _jsx(Typography, { variant: "h3", component: "h1", gutterBottom: true, fontWeight: "700", children: "Homework 6" }), _jsx(Divider, { sx: { my: 3 } }), _jsx(Typography, { variant: "h6", color: "text.secondary", gutterBottom: true, children: "React Routing & MUI Components" })] }) }));
};
export default Home;
